export enum QuestionsTypes {
  SET_QUESTIONS_INITIAL_STATE = 'SET_QUESTIONS_INITIAL_STATE',
  SET_QUESTIONS_MESSAGE_ADDED = 'SET_QUESTIONS_MESSAGE_ADDED',
  SET_NUM_OF_QUESTION_REPLIES_READ = 'SET_NUM_OF_QUESTION_REPLIES_READ',
  SET_QUESTIONS_UPDATED = 'SET_QUESTIONS_UPDATED',
  SET_QUESTIONS_PRIORITY_CHANGED = 'SET_QUESTIONS_PRIORITY_CHANGED',
  SET_QUESTIONS_SYNC_UPDATING = 'SET_QUESTIONS_SYNC_UPDATING',
  SET_QUESTIONS_DOC_UPDATE_LISTENER_ADDED = 'SET_QUESTIONS_DOC_UPDATE_LISTENER_ADDED',
  SET_QUESTIONS_REQUEST_LOADING ='SET_QUESTIONS_REQUEST_LOADING'
}

export interface UserConversationsArrayObjs {
  conversationId: string
  conversationSid: string
  createdDate: Date
  isAnswered: boolean
  isPriority: boolean
  vieingId: string
}

export interface UserConversationsArray {
  userId: string
  userConversations: UserConversationsArrayObjs[]
}

export interface UsersConversationsObj {
  usersConversations: UserConversationsArray[]
}

export interface UsersArrayObjs {
  companyName: string
  externalIdV2: string
  firstName: string
  lastName: string
  photoId: string
  twilioToken: string
}

export interface Users {
  users : UsersArrayObjs[]
}

export interface QuestionsTwilioDocValue {
  uid: number | string
}

export interface QuestionsDocValue {
  conversations: UsersConversationsObj
  users: Users
}

export interface QuestionValueFromDoc {
  id: string;
  isSticky: boolean
  isAnswered: boolean
  uniqueConversationName: string
  user: {
      name: string;
      companyName: string | undefined
      authorExternalIdV2: string | undefined
  }
}